import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-press4',
  templateUrl: './notice-press4.component.html',
  styleUrls: ['./notice-press4.component.scss']
})
export class NoticePress4Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
